import { initializeApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: "AIzaSyAEYtct1rmRpM6oe6jBoAcbQ6PqJaKo93w",
  authDomain: "baatcheet-ac87c.firebaseapp.com",
  projectId: "baatcheet-ac87c",
  storageBucket: "baatcheet-ac87c.firebasestorage.app",
  messagingSenderId: "548789836710",
  appId: "1:548789836710:web:96769aa07a83ecb7824d67",
  measurementId: "G-5K18L3XPSH"
};

export const app = initializeApp(firebaseConfig);
